import React from "react";
import PropTypes from "prop-types";
import { Field, reduxForm } from "redux-form";
import { Form, Grid, Segment } from "semantic-ui-react";
import Header from "semantic-ui-react/dist/commonjs/elements/Header/Header";
import BotonGuardar from "../botones/BotonGuardar";
import ContactosTabla from "./colegioForm/ContactosTabla";
import _ from "lodash";

function renderTextField({ input, meta: { touched, error }, ...others }) {
  return <Form.Input {...input} {...others} />;
}

function renderTabla({ input, meta: { touched, error }, ...others }) {
  return <ContactosTabla {...input} {...others} />;
}

class ColegioForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      contactos: this.props.datos.contactos
    };
  }

  handleChange = value => {
    let data = _.cloneDeep(this.state.contactos);

    this.setState({
      contactos: Object.assign({}, data, value)
    });
  };

  render() {
    const { handleSubmit, pristine, reset, submitSucceeded } = this.props;

    return (
      <Segment basic>
        <Form>
          <Segment>
            <Grid columns="3">
              <Grid.Row>
                <Grid.Column>
                  <label>
                    Nombre
                    <Field
                      required
                      id="nombre"
                      name="nombre"
                      type="text"
                      component={renderTextField}
                    />
                  </label>
                </Grid.Column>
                <Grid.Column>
                  <label>
                    Población
                    <Field
                      id="poblacion"
                      name="poblacion"
                      type="text"
                      component={renderTextField}
                    />
                  </label>
                </Grid.Column>
                <Grid.Column>
                  <label>
                    Provincia
                    <Field
                      id="provincia"
                      name="provincia"
                      type="text"
                      component={renderTextField}
                    />
                  </label>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Segment>

          <Segment>
            <Header as="h4">Datos Contacto</Header>
            <Field
              id="contactos"
              name="contactos"
              component={renderTabla}
              editable
              showAddContacto={this.showAddContacto}
              handleBorrarContacto={this.handleBorrarContacto}
              onChange={this.handleChange}
            />
          </Segment>

          <Segment basic padded="very">
            <BotonGuardar
              disabled={pristine || submitSucceeded}
              floated="right"
              action={handleSubmit(values =>
                this.props.action(values, this.state.contactos)
              )}
              buttontext="Guardando"
              icon="checkmark"
            />
            <BotonGuardar
              disabled={pristine || submitSucceeded}
              floated="right"
              buttonText="Descartar Cambios"
              icon="cancel"
              action={reset}
            />
          </Segment>
        </Form>
      </Segment>
    );
  }
}
ColegioForm.defaultProps = {
  datos: { contactos: {} }
};

ColegioForm.propTypes = {
  action: PropTypes.func.isRequired,
  datos: PropTypes.object
};

export default reduxForm({
  form: "FormularioColegio",
  enableReinitialize: true
})(ColegioForm);



// WEBPACK FOOTER //
// ./src/pages/shared/colegios/ColegioForm.jsx